
import React from "react";
import { FaFacebookF, FaDiscord, FaLinkedinIn } from "react-icons/fa";
import { Button } from "@/components/ui/button";

interface SocialIconProps {
  className?: string;
}

export function SocialIcons({ className }: SocialIconProps) {
  return (
    <div className={`flex space-x-1 ${className}`}>
      <Button size="icon" variant="ghost" className="h-8 w-8 rounded-full">
        <FaFacebookF className="h-4 w-4" />
        <span className="sr-only">Facebook</span>
      </Button>
      <Button size="icon" variant="ghost" className="h-8 w-8 rounded-full">
        <FaDiscord className="h-4 w-4" />
        <span className="sr-only">Discord</span>
      </Button>
      <Button size="icon" variant="ghost" className="h-8 w-8 rounded-full">
        <FaLinkedinIn className="h-4 w-4" />
        <span className="sr-only">LinkedIn</span>
      </Button>
    </div>
  );
}
